import { AntispoofUser, Customer } from "../types";

export const transformAntispoofUsersToUsers = (
  users: AntispoofUser[],
): Customer[] => {
  return users.map((user: AntispoofUser) => {
    return {
      uuid: user.organisation_uuid,
      name: user.name || "",
      email: user.email,
    };
  });
};
